import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BasketCalculatedLineViewModel } from '@models/api-orders.models';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { ProductImageComponent } from '@shared/image/product-image/product-image.component';
import { NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'app-reserve-in-store-line',
    templateUrl: './reserve-in-store-line.component.html',
    styleUrls: ['./reserve-in-store-line.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgClass, ProductImageComponent, TranslateSafePipe]
})
export class ReserveInStoreLineComponent {
    @Input() data: BasketCalculatedLineViewModel | null;
    @Input() pending?: boolean | null = false;
}
